<template>
  <div class="container-withdraw-account" :class="[packageName]">
    <!-- 页眉 -->
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.wd.withdrawAccount') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <!-- 内容 -->
    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>
      <!-- 提现名 -->
      <div class="select">
        <span>{{ $t('lang.wd.cc') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>
      <!-- 如果是银行卡 -->
      <template v-if="bankType.includes(withdrawalMethod)">
        <!-- 如果是印尼 -->
        <template v-if="locaCode === 'ID'">
          <div class="select">
            <span>{{ $t('lang.wd.bankName') }}</span>
            <van-field v-model="bankIndonesiaText" is-link readonly label="" :placeholder="$t('lang.wd.bankName')" @click="showBankPicker = true" />
          </div>
          <div class="select">
            <span>{{ $t('lang.wd.bankAccount') }}</span>
            <input type="number" :placeholder="$t('lang.wd.bankAccount')" @input="onlyMaxLengthNumber" v-model.number="accountId" />
          </div>
          <div class="select">
            <span>{{ $t('lang.wd.accountName') }}</span>
            <input type="text" maxlength="20" :placeholder="$t('lang.wd.phYourName')" v-model.trim="accountName" />
          </div>
          <div class="select">
            <span>{{ $t('lang.wd.phoneNumber') }}</span>
            <div class="phone-number-wrapper">
              <span class="area-wrapper">+62</span>
              <div class="account-line"></div>
              <input type="number" :placeholder="`${$t('lang.wd.phoneNumber')}（eg：12345678910）`" v-model.number="userPhoneNumber" @input="onlyMaxLengthPhoneNumber" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="select">
            <span>{{ $t('lang.wd.name') }}</span>
            <input type="text" :placeholder="$t('lang.wd.name')" v-model.trim="accountName" />
          </div>
          <div class="select">
            <span>{{ $t('lang.wd.phAccount') }}</span>
            <input type="text" maxlength="24" :placeholder="$t('lang.wd.accountMlgPh')" @input="onlyNumber" v-model.number="accountId" />
          </div>
          <!-- 针对摩洛哥，增加银行名字选择 -->
          <div v-if="locaCode === 'MA'" class="select">
            <span>{{ $t('lang.wd.bankName') }}</span>
            <van-field v-model="bankIndonesiaText" is-link readonly label="" :placeholder="$t('lang.wd.bankName')" @click="showBankPicker = true" />
          </div>
        </template>
      </template>
      <!-- 哥伦比亚 且是 Transfer bancaria -->
      <template v-else-if="locaCode === 'CO' && withdrawalMethod === 'Transfer bancaria'">
        <!-- 姓名 -->
        <div class="select">
          <span>Nombre del Cliente</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.accountName" />
        </div>
        <!-- 地址 -->
        <div class="select">
          <span>Dirección del Cliente</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.accountAddress" />
        </div>
        <!-- 选择（身份类型） -->
        <div class="select">
          <span>Identificación del Cliente</span>
          <van-field v-model="pickerTypeValue1" is-link readonly label="" placeholder="Por favor seleccione" @click="showTypePicker1 = true" />
        </div>
        <!-- 身份类型-填写 -->
        <template v-if="pickerTypeValue1 !== ''">
          <div class="select">
            <input
              style="color: #333"
              type="text"
              :maxlength="pickerTypeValue1 === 'Cédula de Identidad' ? 10 : 8"
              :placeholder="pickerTypeValue1 === 'Cédula de Identidad' ? 'Por favor, introduzca 10 caracteres' : 'Ingrese un máximo de 8 dígitos'"
              v-model.trim="columbiaForm.idNumber"
            />
          </div>
        </template>
        <!-- 邮件 -->
        <div class="select">
          <span>Correo Electrónico del Cliente</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.email" />
        </div>
        <!-- 姓氏 -->
        <div class="select">
          <span>Apellido</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.lastName" />
        </div>
        <!-- 电话 -->
        <div class="select">
          <span>Teléfono del Cliente</span>
          <input
            style="color: #333"
            type="number"
            placeholder="Ingrese un máximo de 10 dígitos"
            maxlength="10"
            @input="
              (ev) => {
                columbiaForm.phoneNumber = ev.target.value.slice(0, 10)
              }
            "
            v-model.trim="columbiaForm.phoneNumber"
          />
        </div>
        <!-- 选择（账户类型） -->
        <div class="select">
          <span>Tipo de Cuenta</span>
          <van-field v-model="pickerTypeValue2" is-link readonly label="" placeholder="Por favor seleccione" @click="showTypePicker2 = true" />
        </div>
        <!-- 账户 -->
        <div class="select">
          <span>Cuenta</span>
          <input style="color: #333" type="number" placeholder="Por favor, rellene" v-model.trim="columbiaForm.accountId" />
        </div>
        <!-- 选择（银行） -->
        <div class="select">
          <span>ID del Banco y Nombre del Banco</span>
          <van-field v-model="bankIndonesiaText" is-link readonly label="" :placeholder="$t('lang.wd.bankName')" @click="showBankPicker = true" />
        </div>
      </template>
      <!-- 哥伦比亚 且是 Transfiya bancaria -->
      <template v-else-if="locaCode === 'CO' && withdrawalMethod === 'Transfiya bancaria'">
        <!-- 姓名 -->
        <div class="select">
          <span>Nombre del Cliente</span>
          <input style="color: #333" type="text" placeholder="Por favor, rellene" v-model.trim="columbiaForm.accountName" />
        </div>
        <!-- 选择（身份类型） -->
        <div class="select">
          <span>Identificación del Cliente</span>
          <van-field v-model="pickerTypeValue1" is-link readonly label="" placeholder="Por favor seleccione" @click="showTypePicker1 = true" />
        </div>
        <!-- 身份类型-填写 -->
        <template v-if="pickerTypeValue1 !== ''">
          <div class="select">
            <input
              style="color: #333"
              type="text"
              :maxlength="pickerTypeValue1 === 'Cédula de Identidad' ? 10 : 6"
              :placeholder="pickerTypeValue1 === 'Cédula de Identidad' ? 'Por favor, introduzca 10 caracteres' : 'Por favor, introduzca 6 caracteres'"
              v-model.trim="columbiaForm.idNumber"
            />
          </div>
        </template>
        <!-- 受益人账户 -->
        <div class="select">
          <span>Cuenta beneficiaria</span>
          <input
            style="color: #333"
            type="number"
            placeholder="Ingrese un máximo de 10 dígitos"
            maxlength="10"
            @input="
              (ev) => {
                columbiaForm.accountId = ev.target.value.slice(0, 10)
              }
            "
            v-model.trim="columbiaForm.accountId"
          />
        </div>
        <!-- 选择（银行） -->
        <div class="select">
          <span>Nombre del Banco</span>
          <van-field v-model="bankIndonesiaText" is-link readonly label="" :placeholder="$t('lang.wd.bankName')" @click="showBankPicker = true" />
        </div>
      </template>
      <!-- 不是银行卡 -->
      <template v-else>
        <!-- 如果是沃达丰 或 Orange -->
        <div class="select" v-if="withdrawalMethod == 'Vodafone' || withdrawalMethod == 'Orange'">
          <span>{{ $t('lang.wd.accountNameAr') }}</span>
          <input style="color: #333" type="text" :placeholder="$t('lang.wd.accountNameArTip')" v-model.trim="accountName" />
        </div>
        <template v-else-if="withdrawalMethod == 'Paypal'">
          <div class="select">
            <span>{{ $t('lang.wd.name') }}</span>
            <input style="color: #333" type="text" :placeholder="$t('lang.common.yourRealName')" v-model.trim="accountName" />
          </div>
          <p class="paypal-tips">{{ $t('lang.common.realNameTips') }}</p>
        </template>
        <!-- 否则 -->
        <div class="select" v-else>
          <span>{{ $t('lang.wd.name') }}</span>
          <input style="color: #333" type="text" :placeholder="$t('lang.wd.phYourName')" v-model.trim="accountName" />
        </div>
        <!-- 其余的 -->
        <div class="select">
          <!-- 只有国家是PH的 就有GCASH支付渠道 -->
          <span v-if="withdrawalMethod == 'PIX'">{{ $t('lang.wd.accountPix') }}</span>
          <span v-else-if="withdrawalMethod == 'USDT' || withdrawalMethod == 'USDT(BINANCE)'" type="text">
            {{ $t('lang.wd.binanceAccount') }}
          </span>
          <span v-else-if="withdrawalMethod == 'USDT(TRC20)'" type="text">{{ $t('lang.wd.TRC20Account') }}</span>
          <span v-else-if="withdrawalMethod == 'USDT(TRC20/BEP20)'" type="text">{{ $t('lang.wd.TRC20AccountCoinEX') }} (TRC20/BEP20)</span>
          <span v-else-if="withdrawalMethod == 'Vodafone' || withdrawalMethod == 'Orange'" type="text">{{ $t('lang.wd.accountNoAr') }}</span>
          <span v-else-if="withdrawalMethod == 'Papara'" type="text">{{ $t('lang.wd.paparaAccountNo') }}</span>
          <span v-else>{{ $t('lang.wd.phAccount') }}</span>
          <div class="select-account">
            <div v-if="['OVO', 'DANA'].includes(withdrawalMethod)" class="PH-account arPhAccount">+62</div>
            <div v-else-if="withdrawalMethod == 'GCash'" class="PH-account arPhAccount">+63</div>
            <input v-if="withdrawalMethod == 'PIX'" type="text" placeholder="123.456.789-00" v-model="accountId" onkeyup="value=value.replace(/[^\d.-]/g,'')" />
            <input v-else-if="withdrawalMethod == 'GCash'" type="text" maxlength="10" oninput="value=value.replace(/[^\d]/g,'')" placeholder="GCash Account" v-model="accountId" />
            <input v-else-if="withdrawalMethod == 'USDT' || withdrawalMethod == 'USDT(BINANCE)'" type="text" :placeholder="$t('lang.wd.yourBinanceEmail')" v-model="accountId" />
            <div v-else-if="withdrawalMethod == 'USDT(TRC20)'" class="TRC20-box">
              <input maxlength="34" type="text" :placeholder="$t('lang.wd.TRC20Account')" v-model="accountId" />
              <div class="TRC20-length-tip">{{ accountId.length }}/34</div>
            </div>
            <div v-else-if="withdrawalMethod == 'USDT(TRC20/BEP20)'" class="TRC20-box">
              <input maxlength="42" type="text" :placeholder="$t('lang.wd.TRC20AccountCoinEX')" v-model.trim="accountId" @input="filterNoNumerAndLetter($event, 'accountId')" />
            </div>
            <input v-else-if="withdrawalMethod == 'Paypal'" type="text" :placeholder="$t('lang.wd.paypalTix')" v-model="accountId" />
            <input v-else-if="withdrawalMethod == 'Vodafone'" type="text" maxlength="11" @input="validateInput" @keypress="validateKeypress" @paste.prevent v-model="accountId" />
            <input v-else-if="withdrawalMethod == 'Orange'" type="text" maxlength="11" :placeholder="$t('lang.wd.accountNoArTip')" v-model="accountId" />
            <input
              v-else-if="['OVO', 'DANA'].includes(withdrawalMethod) && locaCode === 'ID'"
              type="text"
              maxlength="14"
              @input="onlyMaxLengthNumberFourteen"
              :placeholder="$t('lang.wd.accountNoArTipId')"
              v-model="accountId"
            />
            <!-- 白维飞：有主播老输入错误， 期望技术上限定一下仅输入数字 -->
            <input v-else-if="withdrawalMethod === 'DANA'" type="text" :placeholder="$t('lang.wd.phAccount')" @input="filterNonNumericChars" v-model="accountId" />
            <input v-else type="text" :placeholder="$t('lang.wd.phAccount')" v-model="accountId" />
          </div>

          <!-- 输入框下面的提示 -->
          <div class="tipTRC20" v-if="withdrawalMethod == 'USDT(TRC20)'">
            <div>* {{ $t('lang.wd.TRC20Tip1') }}</div>
            <div>* {{ $t('lang.wd.TRC20Tip2') }}</div>
          </div>
          <!-- <div class="tipTRC20" v-if="withdrawalMethod == 'USDT(TRC20/BEP20)'">
            <div>* {{ $t("lang.wd.TRC20Tip1CoinEX") }}</div>
          </div> -->
          <div class="tipTRC20-a" v-if="withdrawalMethod == 'USDT(TRC20/BEP20)'">
            *
            <a href="https://www.binance.com/support/faq/detail/115003764971">{{ $t('lang.wd.binanceLink') }}</a>
          </div>
        </div>
        <div class="select" v-if="withdrawalMethod === 'Papara'">
          <span>{{ $t('lang.wd.phoneNumber') }}</span>
          <div class="phone-number-wrapper">
            <span class="area-wrapper">+90</span>
            <div class="account-line"></div>
            <input type="number" :placeholder="`${$t('lang.wd.phoneNumber')}（eg：1234567890）`" v-model.number="userPhoneNumber" @input="onlyMaxLengthNumber10" />
          </div>
        </div>
        <!-- BNB引导增加链地址 -->
        <template v-if="withdrawalMethod === 'USDT(BINANCE)'">
          <div class="select">
            <span>{{ $t('lang.wd.address') }} (TRC20/BEP20)</span>
            <input
              style="color: #333"
              maxlength="42"
              type="text"
              :placeholder="$t('lang.wd.address')"
              v-model.trim="accountAddress"
              @input="filterNoNumerAndLetter($event, 'accountAddress')"
            />
          </div>
          <!-- 新增描述-描述文案去币安 -->
          <div class="tipTRC20-a">
            *
            <a href="https://www.binance.com/support/faq/detail/115003764971">{{ $t('lang.wd.binanceLink') }}</a>
          </div>
        </template>
      </template>
      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ saveBtnAct: this.saveFlag() }" @click="handleSave">
        {{ cfgId ? $t('lang.change') : $t('lang.wd.save') }}
      </div>
    </div>
    <!-- 弹窗 -->
    <van-dialog v-model="showDialog" close-on-click-overlay="true" :showConfirmButton="false">
      <div class="pix-dialog">
        <div class="title">{{ $t('lang.wd.pixDialogTitlt') }}</div>
        <div class="tip">{{ $t('lang.wd.pixDialogTip') }}</div>
        <div class="account">123.456.789-00</div>
      </div>
    </van-dialog>
    <!-- 选择银行弹窗 -->
    <van-popup v-model="showBankPicker" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.cfm.cancelBtn')"
        :confirm-button-text="$t('lang.confirm')"
        :model-value="pickerValue"
        :columns="bankList"
        @cancel="showBankPicker = false"
        @confirm="handleBankPickerConfirm"
      />
    </van-popup>
    <!-- 哥伦比亚-选择类型弹窗-1 -->
    <van-popup v-model="showTypePicker1" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.cfm.cancelBtn')"
        :confirm-button-text="$t('lang.confirm')"
        :model-value="pickerTypeValue1"
        :columns="columbiaList1"
        @cancel="showTypePicker1 = false"
        @confirm="handleTypePickerConfirm1"
      />
    </van-popup>
    <!-- 哥伦比亚-选择类型弹窗-2 -->
    <van-popup v-model="showTypePicker2" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.cfm.cancelBtn')"
        :confirm-button-text="$t('lang.confirm')"
        :model-value="pickerTypeValue2"
        :columns="columbiaList2"
        @cancel="showTypePicker2 = false"
        @confirm="handleTypePickerConfirm2"
      />
    </van-popup>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiFetchWithdrawAccount, apiEditWithdrawAccount, apiGetColumbiaBankList } from '@/api/imee.js'
import _debounce from 'lodash/debounce' // 防抖
import { bankType, bankIndonesiaList, bankIndonesiaListMA, columbiaList1, columbiaList2 } from './constant'

export default {
  components: {},
  props: {},
  data() {
    const query = this.$route.query
    return {
      walletType: query.walletType,
      barHeight: query.statusBarHeight || 38,
      // accountName: query.accountName || 'Bank', // 账号名称
      icon: query.icon || null, // 图标
      locaFlag: query.locaFlag || null, // 国旗图片
      locaCode: query.locaCode || null, // 国家代码 ID是印尼, TR是土耳其 MA是摩洛哥 CO是哥伦比亚
      withdrawalMethod: query.withdrawalMethod || null, // 提现类型
      minDollarAmount: query.minDollarAmount || null,
      accountName: '', // 账号名称
      accountId: '', // 提现账号
      timer: null,
      change: query.change || null,
      cfgId: '',
      showDialog: false, // 弹窗提醒 判断pix 填写的格式  12345678900 或者 123.456.789-00
      bankCode: '', // 印度绑定提现方式填写的（银行编码）
      bankType, // 银行卡类型（不知道为什么，有两种值'Bank Transfer', 'Bank'）
      bankIndonesiaList, // 银行卡选项（印尼）
      bankIndonesiaListMA, // 银行卡选项（摩洛哥）
      pickerValue: '', // Picker值（印尼，摩洛哥）
      showBankPicker: false, // Picker显示（印尼，摩洛哥）
      bankIndonesiaText: '', // 银行显示名（印尼，摩洛哥，哥伦比亚）
      userPhoneNumber: '', // 用户手机号（印尼）
      bankList: [],
      columbiaList1,
      columbiaList2,
      pickerTypeValue1: '',
      pickerTypeValue2: '',
      showTypePicker1: false,
      showTypePicker2: false,
      columbiaForm: {
        accountName: '',
        accountAddress: '',
        idNumber: '',
        email: '',
        lastName: '',
        phoneNumber: '',
        idType: '',
        accountType: '',
        accountId: '',
        bankCode: ''
      },
      accountAddress: ''
    }
  },
  mounted() {
    if (this.locaCode === 'MA') {
      this.bankList = bankIndonesiaListMA
    } else if (this.locaCode === 'ID') {
      this.bankList = bankIndonesiaList
    } else if (this.locaCode === 'CO') {
      this.handleGetColumbiaBankList()
    }
    if (this.change) {
      this.fetchWithdrawAccount()
    }
  },
  methods: {
    validateInput(event) {
      // 使用正则表达式移除非阿拉伯数字的字符
      this.accountId = this.accountId.replace(/[^0-9]/g, '')
    },
    validateKeypress(event) {
      // 允许的键为 0-9 的阿拉伯数字
      const charCode = event.keyCode || event.which
      if (charCode < 48 || charCode > 57) {
        event.preventDefault()
      }
    },

    // 绑定账号
    handleSave: _debounce(
      function () {
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '') // 去掉字符串所有空格
        // 判断字符串里面有没有emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          this.$client.showToast(this.$t('lang.wd.emojiTip'))
          return
        }
        // 如果是pix
        if (this.withdrawalMethod === 'PIX') {
          const tempFlag =
            this.accountId.length === 11 ||
            (this.accountId.length === 14 && this.accountId.charAt(3) === '.' && this.accountId.charAt(7) === '.' && this.accountId.charAt(11) === '-')
          if (!tempFlag) {
            this.showDialog = true
            return
          }
        }
        // 如果是USDT、USDT(BINANCE)、Paypal
        if (this.withdrawalMethod === 'USDT' || this.withdrawalMethod === 'USDT(BINANCE)' || this.withdrawalMethod === 'Paypal') {
          // 为usdt的时候  验证邮箱格式
          const mailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          if (!mailReg.test(this.accountId)) {
            this.accountId = ''
            if (this.withdrawalMethod === 'Paypal') {
              this.$client.showToast(this.$t('lang.wd.paypalEmailTip'))
            } else {
              this.$client.showToast(this.$t('lang.wd.usdtEmailTip'))
            }
            return
          }
        }
        // 如果是USDT(TRC20)
        if (this.withdrawalMethod === 'USDT(TRC20)') {
          if (this.accountId.length !== 34) {
            this.accountId = ''
            this.$client.showToast(this.$t('lang.wd.TRC20WrongTip'))
            return
          }
        }
        // 如果是USDT(TRC20/BEP20)
        if (this.withdrawalMethod === 'USDT(TRC20/BEP20)') {
          if (![34, 42].includes(this.accountId.length)) {
            this.accountId = ''
            this.$client.showToast(this.$t('lang.wd.TRC20OrBEP20WrongTipLength'))
            return
          }

          // 地址开头校验
          if (!/^(T|0x).*/.test(this.accountId)) {
            this.accountId = ''
            this.$client.showToast(this.$t('lang.wd.TRC20OrBEP20WrongTipBegin'))
            return
          }

          // TRC20字符集校验
          if (this.accountId.length === 34 && /^T/.test(this.accountId) && !/^[A-Za-z0-9]+$/.test(this.accountId)) {
            this.accountId = ''
            this.$client.showToast(this.$t('lang.wd.TRC20WrongTipChars'))
            return
          }

          // BEP20字符集校验
          if (this.accountId.length === 42 && /^0x/.test(this.accountId) && !/^[0-9a-f]+$/i.test(this.accountId.slice(2))) {
            this.accountId = ''
            this.$client.showToast(this.$t('lang.wd.BEP20WrongTipChars'))
            return
          }
          this.accountAddress = this.accountId
        }

        // 如果是银行卡
        if (this.bankType.includes(this.withdrawalMethod)) {
          if (this.locaCode === 'MA') {
            if (this.accountId.length < 24) {
              this.$client.showToast(this.$t('lang.wd.accountMlgPhTip'))
              return
            }
            if (!this.bankCode) {
              this.$client.showToast(this.$t('lang.wd.bankName'))
              return
            }
          }
          // 印尼
          if (this.locaCode === 'ID') {
            if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
              this.$client.showToast(this.$t('lang.wd.accountMlgPhTip'))
              return
            }
            if (`${this.userPhoneNumber}`.length > 14 || `${this.userPhoneNumber}`.length < 10) {
              this.$client.showToast(this.$t('lang.wd.accountNoArTipId'))
              return
            }
            if (`${this.accountId}`.length !== 11) {
              this.$client.showToast(this.$t('lang.wd.accountNoArTip'))
              return
            }
          }
        }
        // 如果是印尼且是'OVO', 'DANA'
        if (['OVO', 'DANA'].includes(this.withdrawalMethod) && this.locaCode === 'ID') {
          if (`${this.accountId}`.length > 14 || `${this.accountId}`.length < 10) {
            this.$client.showToast(this.$t('lang.wd.accountNoArTipId'))
            return
          }
        }
        // 如果是沃达丰
        if (this.withdrawalMethod === 'Vodafone') {
          if (this.accountId.length !== 11) {
            this.$client.showToast(this.$t('lang.wd.accountNoArTip'))
            return
          }
        }
        // 土耳其
        if (this.withdrawalMethod === 'Papara') {
          if (`${this.userPhoneNumber}`.length !== 10) {
            this.$client.showToast(this.$t('lang.wd.accountNoArTip10'))
            return
          }
        }

        // 先验证完之后 根据cfgId 是走修改的逻辑 还是存账号逻辑
        if (this.cfgId) {
          this.editAccount()
          return
        }

        let data = {
          accountId: this.accountId,
          accountName: this.accountName,
          withdrawalMethod: this.withdrawalMethod // 提现方式 支持 PIX,Paypal,Payoneer
        }

        if (this.withdrawalMethod === 'GCash') {
          data.accountId = '63' + this.accountId
        }

        // 如果是银行卡
        if (this.bankType.includes(this.withdrawalMethod)) {
          data.bankCode = this.bankCode
          // 如果是印尼
          if (this.locaCode === 'ID') {
            data.phoneNumber = this.userPhoneNumber
          }
        }
        // 土耳其
        if (this.withdrawalMethod === 'Papara') {
          data.phoneNumber = this.userPhoneNumber
        }
        // 哥伦比亚
        if (this.locaCode === 'CO') {
          // 哥伦比亚的 Transfer bancaria
          if (this.withdrawalMethod === 'Transfer bancaria') {
            data = {}
            data = {
              accountAddress: this.columbiaForm.accountAddress,
              accountId: this.columbiaForm.accountId,
              accountName: this.columbiaForm.accountName,
              accountType: this.columbiaForm.accountType,
              bankCode: this.columbiaForm.bankCode,
              email: this.columbiaForm.email,
              idNumber: this.columbiaForm.idNumber,
              idType: this.columbiaForm.idType,
              lastName: this.columbiaForm.lastName,
              phoneNumber: this.columbiaForm.phoneNumber,
              withdrawalMethod: this.withdrawalMethod
            }
            const targetLength = `${this.columbiaForm.idNumber}`.length
            if (this.pickerTypeValue1 === 'Cédula de Identidad' && (targetLength < 6 || targetLength > 10)) {
              this.$client.showToast('Cédula de Identidad Por favor ingrese 10 dígitos')
              return
            }
            if (this.pickerTypeValue1 === 'Cédula de Identidad de Extranjero' && (targetLength === 0 || targetLength > 8)) {
              this.$client.showToast('Ingrese un máximo de 8 dígitos')
              return
            }
            if (`${this.columbiaForm.phoneNumber}`.length < 10) {
              this.$client.showToast('Teléfono del Cliente Por favor ingrese 10 dígitos')
              return
            }
          }
          // 哥伦比亚的 Transfiya bancaria
          if (this.withdrawalMethod === 'Transfiya bancaria') {
            data = {}
            data = {
              accountId: this.columbiaForm.accountId,
              accountName: this.columbiaForm.accountName,
              bankCode: this.columbiaForm.bankCode,
              idNumber: this.columbiaForm.idNumber,
              idType: this.columbiaForm.idType,
              withdrawalMethod: this.withdrawalMethod
            }
            const targetLength = `${this.columbiaForm.idNumber}`.length
            if (this.pickerTypeValue1 === 'Cédula de Identidad' && (targetLength < 6 || targetLength > 10)) {
              this.$client.showToast('Cédula de Identidad Por favor ingrese 10 dígitos')
              return
            }
            if (this.pickerTypeValue1 === 'Cédula de Identidad de Extranjero' && (targetLength === 0 || targetLength > 6)) {
              this.$client.showToast('Cédula de Identidad de Extranjero Por favor ingrese 6 dígitos')
              return
            }
            if (`${this.columbiaForm.accountId}`.length < 10) {
              this.$client.showToast('Cuenta Por favor ingrese 10 dígitos')
              return
            }
          }
        }
        // BNB引导增加链地址
        if (this.withdrawalMethod === 'USDT(BINANCE)' || this.withdrawalMethod === 'USDT(TRC20/BEP20)') {
          if (![34, 42].includes(this.accountAddress.length)) {
            this.accountAddress = ''
            this.$client.showToast(this.$t('lang.wd.TRC20OrBEP20WrongTipLength'))
            return
          }

          // 地址开头校验
          if (!/^(T|0x).*/.test(this.accountAddress)) {
            this.accountAddress = ''
            this.$client.showToast(this.$t('lang.wd.TRC20OrBEP20WrongTipBegin'))
            return
          }

          // TRC20字符集校验
          if (this.accountAddress.length === 34 && /^T/.test(this.accountAddress) && !/^[A-Za-z0-9]+$/.test(this.accountAddress)) {
            this.accountAddress = ''
            this.$client.showToast(this.$t('lang.wd.TRC20WrongTipChars'))
            return
          }

          // BEP20字符集校验
          if (this.accountAddress.length === 42 && /^0x/.test(this.accountAddress) && !/^[0-9a-f]+$/i.test(this.accountAddress.slice(2))) {
            this.accountAddress = ''
            this.$client.showToast(this.$t('lang.wd.BEP20WrongTipChars'))
            return
          }

          data.accountAddress = this.accountAddress
        }

        apiBindWithdrawAccount(data).then((res) => {
          if (res.status === 200) {
            this.$client.showToast(res.message)
            this.timer = setTimeout(() => {
              this.$router.replace({
                path: '/withdrawal',
                query: {
                  withdrawalMethod: this.withdrawalMethod,
                  icon: this.icon,
                  minPrice: this.minDollarAmount,
                  walletType: this.walletType
                }
              })
            }, 500)
          }
        })
      },
      3000,
      {
        // lodash默认leading为false、trailing为true，那么最终的效果是在点击后等待5秒才会打印debounce，即延迟之前不执行函数，而是在延迟之后执行
        leading: true, // 指定在延迟开始前调用，默认false
        trailing: false // 指定在延迟 默认true
      }
    ),

    // 修改账号
    editAccount() {
      let data = {
        accountId: this.accountId,
        accountName: this.accountName
      }
      if (this.withdrawalMethod === 'GCash') {
        data.accountId = '63' + this.accountId
      }
      // 如果是银行卡
      if (this.bankType.includes(this.withdrawalMethod)) {
        // 如果是印尼
        if (this.locaCode === 'ID') {
          data.phoneNumber = this.userPhoneNumber
        }
        data.bankCode = this.bankCode
      }
      // 如果是银行卡
      if (this.bankType.includes(this.withdrawalMethod)) {
        if (this.locaCode === 'MA' && this.accountId.length < 24) {
          this.$client.showToast(this.$t('lang.wd.accountMlgPhTip'))
          return
        }
        // 印尼
        if (this.locaCode === 'ID') {
          if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
            this.$client.showToast(this.$t('lang.wd.accountMlgPhTip'))
            return
          }
          if (`${this.userPhoneNumber}`.length > 14 || `${this.userPhoneNumber}`.length < 10) {
            this.$client.showToast(this.$t('lang.wd.accountNoArTipId'))
            return
          }
          if (`${this.accountId}`.length !== 11) {
            this.$client.showToast(this.$t('lang.wd.accountNoArTip'))
            return
          }
        }
      }
      // 如果是印尼且是'OVO', 'DANA'
      if (['OVO', 'DANA'].includes(this.withdrawalMethod) && this.locaCode === 'ID') {
        if (`${this.accountId}`.length > 14 || `${this.accountId}`.length < 10) {
          this.$client.showToast(this.$t('lang.wd.accountNoArTipId'))
          return
        }
      }
      // 土耳其
      if (this.withdrawalMethod === 'Papara') {
        if (`${this.userPhoneNumber}`.length !== 10) {
          this.$client.showToast(this.$t('lang.wd.accountNoArTip10'))
          return
        }
      }
      // 土耳其
      if (this.withdrawalMethod === 'Papara') {
        data.phoneNumber = this.userPhoneNumber
      }
      // 哥伦比亚
      if (this.locaCode === 'CO') {
        // 哥伦比亚的 Transfer bancaria
        if (this.withdrawalMethod === 'Transfer bancaria') {
          data = {}
          data = {
            accountAddress: this.columbiaForm.accountAddress,
            accountId: this.columbiaForm.accountId,
            accountName: this.columbiaForm.accountName,
            accountType: this.columbiaForm.accountType,
            bankCode: this.columbiaForm.bankCode,
            email: this.columbiaForm.email,
            idNumber: this.columbiaForm.idNumber,
            idType: this.columbiaForm.idType,
            lastName: this.columbiaForm.lastName,
            phoneNumber: this.columbiaForm.phoneNumber,
            withdrawalMethod: this.withdrawalMethod
          }
          const targetLength = `${this.columbiaForm.idNumber}`.length
          if (this.pickerTypeValue1 === 'Cédula de Identidad' && (targetLength < 6 || targetLength > 10)) {
            this.$client.showToast('Cédula de Identidad Por favor ingrese 10 dígitos')
            return
          }
          if (this.pickerTypeValue1 === 'Cédula de Identidad de Extranjero' && (targetLength === 0 || targetLength > 8)) {
            this.$client.showToast('Ingrese un máximo de 8 dígitos')
            return
          }
          if (`${this.columbiaForm.phoneNumber}`.length < 10) {
            this.$client.showToast('Teléfono del Cliente Por favor ingrese 10 dígitos')
            return
          }
        }
        // 哥伦比亚的 Transfiya bancaria
        if (this.withdrawalMethod === 'Transfiya bancaria') {
          data = {}
          data = {
            accountId: this.columbiaForm.accountId,
            accountName: this.columbiaForm.accountName,
            bankCode: this.columbiaForm.bankCode,
            idNumber: this.columbiaForm.idNumber,
            idType: this.columbiaForm.idType,
            withdrawalMethod: this.withdrawalMethod
          }
          const targetLength = `${this.columbiaForm.idNumber}`.length
          if (this.pickerTypeValue1 === 'Cédula de Identidad' && (targetLength < 6 || targetLength > 10)) {
            this.$client.showToast('Cédula de Identidad Por favor ingrese 10 dígitos')
            return
          }
          if (this.pickerTypeValue1 === 'Cédula de Identidad de Extranjero' && (targetLength === 0 || targetLength > 6)) {
            this.$client.showToast('Cédula de Identidad de Extranjero Por favor ingrese 6 dígitos')
            return
          }
          if (`${this.columbiaForm.accountId}`.length < 10) {
            this.$client.showToast('Cuenta Por favor ingrese 10 dígitos')
            return
          }
        }
      }
      // BNB引导增加链地址
      if (this.withdrawalMethod === 'USDT(BINANCE)' || this.withdrawalMethod === 'USDT(TRC20/BEP20)') {
        if (![34, 42].includes(this.accountAddress.length)) {
          this.accountAddress = ''
          this.$client.showToast(this.$t('lang.wd.TRC20OrBEP20WrongTipLength'))
          return
        }

        // 地址开头校验
        if (!/^(T|0x).*/.test(this.accountAddress)) {
          this.accountAddress = ''
          this.$client.showToast(this.$t('lang.wd.TRC20OrBEP20WrongTipBegin'))
          return
        }

        // TRC20字符集校验
        if (this.accountAddress.length === 34 && /^T/.test(this.accountAddress) && !/^[A-Za-z0-9]+$/.test(this.accountAddress)) {
          this.accountAddress = ''
          this.$client.showToast(this.$t('lang.wd.TRC20WrongTipChars'))
          return
        }

        // BEP20字符集校验
        if (this.accountAddress.length === 42 && /^0x/.test(this.accountAddress) && !/^[0-9a-f]+$/i.test(this.accountAddress.slice(2))) {
          this.accountAddress = ''
          this.$client.showToast(this.$t('lang.wd.BEP20WrongTipChars'))
          return
        }

        data.accountAddress = this.accountAddress
      }
      apiEditWithdrawAccount(data, this.cfgId).then((res) => {
        if (res.status === 200) {
          this.$client.showToast(res.message)
          this.timer = setTimeout(() => {
            this.$router.replace({
              path: '/withdrawal',
              query: {
                withdrawalMethod: this.withdrawalMethod,
                icon: this.icon,
                minPrice: this.minDollarAmount,
                walletType: this.walletType
              }
            })
          }, 500)
        }
      })
    },

    // 统一验证
    validate() {
      if (this.withdrawalMethod === 'GCash') {
        if (this.accountName && this.accountId.length === 10) {
          return true
        }
        return false
      }
      if (this.withdrawalMethod === 'Vodafone' || this.withdrawalMethod === 'Orange') {
        if (this.bankCode && this.accountId && this.accountName) {
          return true
        }
        return false
      }
      if (this.accountId && this.accountName) {
        return true
      }
    },

    // 保存按钮的校验
    saveFlag() {
      // 哥伦比亚的 Transfer bancaria
      if (this.withdrawalMethod === 'Transfer bancaria' && this.locaCode === 'CO') {
        if (
          this.columbiaForm.accountAddress &&
          this.columbiaForm.accountId &&
          this.columbiaForm.accountName &&
          this.columbiaForm.accountType &&
          this.columbiaForm.bankCode &&
          this.columbiaForm.email &&
          this.columbiaForm.idNumber &&
          this.columbiaForm.idType &&
          this.columbiaForm.lastName &&
          this.columbiaForm.phoneNumber
        ) {
          return true
        }
        return false
      }
      // 哥伦比亚的 Transfiya bancaria
      if (this.withdrawalMethod === 'Transfiya bancaria' && this.locaCode === 'CO') {
        if (this.columbiaForm.accountId && this.columbiaForm.accountName && this.columbiaForm.bankCode && this.columbiaForm.idNumber && this.columbiaForm.idType) {
          return true
        }
        return false
      }
      if (this.withdrawalMethod === 'GCash') {
        if (this.accountName && this.accountId.length === 10) {
          return true
        }
        return false
      }
      // 银行
      if (this.bankType.includes(this.withdrawalMethod)) {
        // 是印尼
        if (this.locaCode === 'ID') {
          if (this.bankCode && this.accountId && this.accountName && this.userPhoneNumber) {
            return true
          } else {
            return false
          }
        }
        // 是摩洛哥
        if (this.locaCode === 'MA') {
          if (this.bankCode && this.accountId && this.accountName) {
            return true
          } else {
            return false
          }
        }
      }
      if (this.withdrawalMethod === 'Papara') {
        if (`${this.userPhoneNumber}`.length === 10) {
          return true
        }
        return false
      }
      if (this.withdrawalMethod === 'USDT(BINANCE)') {
        if (this.accountAddress) {
          return true
        }
        return false
      }
      if (this.accountId && this.accountName) {
        return true
      }
    },

    // 获取提现账户方式-详情
    fetchWithdrawAccount() {
      apiFetchWithdrawAccount().then((res) => {
        if (res) {
          res.forEach((item) => {
            if (item.withdrawalMethod === this.withdrawalMethod) {
              this.accountId = item.accountId
              this.accountName = item.accountName
              this.cfgId = item.cfgId
              this.bankCode = item.bankCode || ''
              // 如果是银行
              if (this.bankType.includes(this.withdrawalMethod)) {
                // 如果是印尼银行
                if (this.locaCode === 'ID') {
                  this.userPhoneNumber = item.phoneNumber
                  const target = bankIndonesiaList.find((son) => son.value === item.bankCode) || {}
                  this.bankIndonesiaText = target.text || ''
                }
                // 如果是摩洛哥银行
                if (this.locaCode === 'MA') {
                  const target = bankIndonesiaListMA.find((son) => son.value === item.bankCode) || {}
                  this.bankIndonesiaText = target.text || ''
                }
              }
              if (this.withdrawalMethod === 'Papara') {
                this.userPhoneNumber = item.phoneNumber
              }
              // 哥伦比亚的 Transfer bancaria
              if (this.withdrawalMethod === 'Transfer bancaria' && this.locaCode === 'CO') {
                this.columbiaForm.accountAddress = item.accountAddress || ''
                this.columbiaForm.accountId = item.accountId || ''
                this.columbiaForm.accountName = item.accountName || ''
                this.columbiaForm.accountType = item.accountType || ''
                this.columbiaForm.bankCode = item.bankCode || ''
                this.columbiaForm.email = item.email || ''
                this.columbiaForm.idNumber = item.idNumber || ''
                this.columbiaForm.idType = item.idType || ''
                this.columbiaForm.lastName = item.lastName || ''
                this.columbiaForm.phoneNumber = item.phoneNumber || ''
                // 回显ID类型
                const target1 = columbiaList1.find((v) => v.value === item.idType) || {}
                this.pickerTypeValue1 = target1.text || ''
                // 回显账户类型
                const target2 = columbiaList2.find((v) => v.value === item.accountType) || {}
                this.pickerTypeValue2 = target2.text || ''
                // 回显银行
                const target3 = this.bankList.find((v) => v.value === item.bankCode) || {}
                this.bankIndonesiaText = target3.text || ''
              }
              // 哥伦比亚的 Transfiya bancaria
              if (this.withdrawalMethod === 'Transfiya bancaria' && this.locaCode === 'CO') {
                this.columbiaForm.accountId = item.accountId || ''
                this.columbiaForm.accountName = item.accountName || ''
                this.columbiaForm.bankCode = item.bankCode || ''
                this.columbiaForm.idNumber = item.idNumber || ''
                this.columbiaForm.idType = item.idType || ''
                // 回显ID类型
                const target1 = columbiaList1.find((v) => v.value === item.idType) || {}
                this.pickerTypeValue1 = target1.text || ''
                // 回显银行
                const target3 = this.bankList.find((v) => v.value === item.bankCode) || {}
                this.bankIndonesiaText = target3.text || ''
              }
              // BNB引导增加链地址
              if (this.withdrawalMethod === 'USDT(BINANCE)') {
                this.accountAddress = item.accountAddress || ''
              }
              // USDT(TRC20/BEP20)提现修改和USDT(BINANCE)一致
              if (this.withdrawalMethod === 'USDT(TRC20/BEP20)') {
                this.accountAddress = item.accountAddress || item.accountId
              }
            }
          })
        }
      })
    },
    // 只允许输入数字 0-9
    onlyNumber(event) {
      const value = event.target.value
      // 只允许输入数字
      if (/^[0-9]*$/.test(value)) {
        this.accountId = value
      } else {
        event.target.value = this.accountId // 恢复之前合法的值
      }
    },
    // 只允许输入11位数
    onlyMaxLengthNumber(event) {
      // 防止科学计数法等非标准格式
      if (event.target.value && event.target.value.length > 11) {
        this.accountId = event.target.value.slice(0, 11)
      }
    },
    // 只允许输入14位，且是数字
    onlyMaxLengthNumberFourteen(event) {
      this.accountId = event.target.value.replace(/\D/g, '')
      // 防止科学计数法等非标准格式
      if (this.accountId && this.accountId > 14) {
        this.accountId = this.accountId.slice(0, 14)
      }
    },
    // 只允许输入14位手机号(印尼)
    onlyMaxLengthPhoneNumber(event) {
      // 防止科学计数法等非标准格式
      if (event.target.value && event.target.value.length > 14) {
        this.userPhoneNumber = event.target.value.slice(0, 14)
      }
    },
    // 只允许输入10位数（土耳其）
    onlyMaxLengthNumber10(event) {
      // 防止科学计数法等非标准格式
      if (event.target.value && event.target.value.length > 11) {
        this.userPhoneNumber = event.target.value.slice(0, 10)
      }
    },
    // 选中银行卡（印尼，摩洛哥，哥伦比亚）
    handleBankPickerConfirm(item) {
      this.bankIndonesiaText = item.text
      this.bankCode = item.value
      this.columbiaForm.bankCode = item.value
      this.showBankPicker = false
    },
    /**
     * @description 获取银行列表（哥伦比亚）
     */
    handleGetColumbiaBankList() {
      apiGetColumbiaBankList()
        .then((res) => {
          const resData = res || []
          const list = resData.map((v) => {
            return {
              text: v.bankName || '',
              value: v.bankCode || ''
            }
          })
          this.bankList = list
          if (this.bankCode) {
            // 回显银行
            const target = this.bankList.find((v) => v.value === this.bankCode) || {}
            this.bankIndonesiaText = target.text || ''
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    // 选中类型1（哥伦比亚）
    handleTypePickerConfirm1(item) {
      this.pickerTypeValue1 = item.text
      this.columbiaForm.idType = item.value
      this.columbiaForm.idNumber = ''
      this.showTypePicker1 = false
    },
    // 选中类型2（哥伦比亚）
    handleTypePickerConfirm2(item) {
      this.pickerTypeValue2 = item.text
      this.columbiaForm.accountType = item.value
      this.showTypePicker2 = false
    },
    // 如果输入的值不是有效的数字，则移除非数字字符
    filterNonNumericChars(event) {
      this.accountId = event.target.value.replace(/\D/g, '')
    },
    // 如果输入的值不是有效的数字和字母，则移除非数字字符
    filterNoNumerAndLetter(event, key) {
      this[key] = event.target.value.replace(/[^a-zA-Z0-9]/g, '')
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.container-withdraw-account {
  width: 100%;
  min-height: 100vh;
  background: #f7f6f9;
  padding-bottom: 30px;

  .main {
    padding: 0 16px;
    width: 100%;
  }

  .account-tit {
    display: flex;
    align-items: center;
    width: 100%;
    height: 68px;
    margin: 30px auto;
    padding: 0 24px;
    background: #ffffff;
    border-radius: 10px;

    .account-img {
      text-align: center;

      > img {
        height: 24px;
      }
    }

    .account-name {
      height: 17px;
      font-size: 14px;
      font-family: Inter-Medium;
      font-weight: 500;
      color: #333333;
      line-height: 17px;
    }

    .line {
      height: 20px;
      border-left: 1px solid #ccc;
      margin: 0 20px;
    }
  }

  .select {
    font-size: 16px;
    margin-top: 30px;

    > span {
      display: block;
      margin-bottom: 16px;
      font-size: 16px;
      font-family: Inter-Medium;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
    }

    input,
    .country {
      width: 100%;
      height: 50px;
      padding: 0 14px !important;
      background: #ffffff;
      border-radius: 10px;
      font-size: 14px;
      border: 1px solid #fff;
    }

    .country {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: Inter-Regular;
      font-weight: 400;
      color: #333333;

      > img {
        height: 24px;
        margin: 0 10px;
      }
    }

    .select-account {
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: 10px;
      font-size: 14px;

      .PH-account {
        height: 24px;
        line-height: 24px;
        padding: 0 14px;
        border-right: 1px solid #d8d8d8;
        color: #333;
      }

      > input {
        padding-right: 0;
        color: #333;
      }
    }

    .tipTRC20 {
      margin-top: 10px;
      font-size: 10px;
      font-family: Inter-Medium;
      font-weight: 400;
      color: #999;
      line-height: 15px;
    }

    .TRC20-box {
      width: 100%;
      position: relative;

      .TRC20-length-tip {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 12px;
      }
    }

    .phone-number-wrapper {
      width: 100%;
      border-radius: 4px;
      background-color: #fff;
      overflow: hidden;
      padding-left: 14px;
      display: flex;
      align-items: center;
      justify-content: center;

      .area-wrapper {
        font-size: 16px;
        color: #333333;
      }

      .account-line {
        height: 20px;
        border-left: 1px solid #ccc;
        margin: 0px 2px 0px 16px;
      }
    }
  }

  .save-btn {
    width: 289px;
    height: 40px;
    margin: 40px auto 0;
    background: #e1e1e1;
    border-radius: 22px;
    font-size: 16px;
    font-family: Inter-Medium;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    pointer-events: none;
  }

  .saveBtnAct {
    background: #a338fc;
    pointer-events: auto;
  }

  .pix-dialog {
    width: 90%;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .title {
      color: #000;
      font-weight: 700;
    }

    .tip {
      color: #000;
      margin: 20px 0;
    }

    .account {
      color: #e45b56;
      font-size: 20px;
      font-weight: bold;
    }
  }

  input::-webkit-input-placeholder {
    color: #d8d8d8;
  }
}

.container-withdraw-account.kiko {
  width: 100%;
  min-height: 100vh;
  background: #f7f6f9;
  padding-bottom: 30px;

  .main {
    padding: 0 16px;
    width: 100%;
  }

  .account-tit {
    display: flex;
    align-items: center;
    width: 100%;
    height: 68px;
    margin: 30px auto;
    padding: 0 24px;
    background: #ffffff;
    border-radius: 10px;

    .account-img {
      text-align: center;

      > img {
        height: 24px;
      }
    }

    .account-name {
      height: 17px;
      font-size: 14px;
      font-family: Inter-Medium;
      font-weight: 500;
      color: #333333;
      line-height: 17px;
    }

    .line {
      height: 20px;
      border-left: 1px solid #ccc;
      margin: 0 20px;
    }
  }

  .select {
    font-size: 16px;
    margin-top: 30px;

    > span {
      display: block;
      margin-bottom: 16px;
      font-size: 16px;
      font-family: Inter-Medium;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
    }

    input,
    .country {
      width: 100%;
      height: 50px;
      padding: 0 14px !important;
      background: #ffffff;
      border-radius: 10px;
      font-size: 14px;
      border: 1px solid #fff;
    }

    .country {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: Inter-Regular;
      font-weight: 400;
      color: #333333;

      > img {
        height: 24px;
        margin: 0 10px;
      }
    }

    .select-account {
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: 10px;
      font-size: 14px;

      .PH-account {
        height: 24px;
        line-height: 24px;
        padding: 0 14px;
        border-right: 1px solid #d8d8d8;
        color: #333;
      }

      > input {
        padding-right: 0;
        color: #333;
      }
    }

    .tipTRC20 {
      margin-top: 10px;
      font-size: 10px;
      font-family: Inter-Medium;
      font-weight: 400;
      color: #999;
      line-height: 15px;
    }

    .TRC20-box {
      width: 100%;
      position: relative;

      .TRC20-length-tip {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 12px;
      }
    }

    .phone-number-wrapper {
      width: 100%;
      border-radius: 4px;
      background-color: #fff;
      overflow: hidden;
      padding-left: 14px;
      display: flex;
      align-items: center;
      justify-content: center;

      .area-wrapper {
        font-size: 16px;
        color: #333333;
      }

      .account-line {
        height: 20px;
        border-left: 1px solid #ccc;
        margin: 0px 2px 0px 16px;
      }
    }
  }

  .save-btn {
    width: 289px;
    height: 40px;
    margin: 40px auto 0;
    background: #e1e1e1;
    border-radius: 22px;
    font-size: 16px;
    font-family: Inter-Medium;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    pointer-events: none;
  }

  .saveBtnAct {
    background: #ffe242;
    color: #000000;
    pointer-events: auto;
  }

  .pix-dialog {
    width: 90%;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .title {
      color: #000;
      font-weight: 700;
    }

    .tip {
      color: #000;
      margin: 20px 0;
    }

    .account {
      color: #e45b56;
      font-size: 20px;
      font-weight: bold;
    }
  }

  input::-webkit-input-placeholder {
    color: #d8d8d8;
  }
}

::v-deep .van-toast {
  word-wrap: break-word;
  word-break: normal;
}

.paypal-tips {
  font-size: 12px;
  font-family: Inter-Regular;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 8px;
}

.tipTRC20-a {
  font-size: 12px;
  font-family: Inter-Medium;
  font-weight: 400;
  color: #336df4;
  line-height: 36px;
}
</style>
